import * as React from "react";
import { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import pageIds from "pageIds";
import { CommonConfigurationNodesOverview, CommonConfigurationNodesTopics } from "../../CommonComponents/CommonConfigurationNodesViews";

export const ConfigurationNodesRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.configuration.nodes.root,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonConfigurationNodesOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonConfigurationNodesTopics />;
    }
};
